import React from 'react';
import {BookDetail, BookSEOPage, PageResponseDTOObject} from '../types';

export interface BookSEOPageContextType {
  bookDetail?: BookDetail;
  bookSEOPage?: BookSEOPage;
  landingBookPage?: PageResponseDTOObject;
  relatedBooks?: BookDetail[];
  featuredBooks?: BookDetail[];
}

export const BookSEOPageContext = React.createContext<BookSEOPageContextType>(null);

export const useBookSEOPageContext = () => React.useContext(BookSEOPageContext);
